import { Box, Button, Grid, Stack } from '@mui/material';
// import React, { useEffect } from 'react';
import DatePickerCustom from '../../../components/DatePicker/DatePickerCustom';
import dayjs from 'dayjs';
// import GlobalSelectFieldWithoutFormikNew from '../../../components/mui/GlobalSelectFieldWithoutFormikNew';
// import { useDispatch } from 'react-redux';
/* import { getAllDepartmenst } from '../../../redux/features/postWorkingHoursSlice';
import { useSelector } from 'react-redux';
 */
const FilterSectionFromToSubmit = ({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  selectedDepartment,
  setSelectedDepartment,
  submitFunction,
  handleClearFilter,
}) => {
  // const { departments } = useSelector((store) => store.postWorking);
  /* const dispatch = useDispatch();
  useEffect(() => {
    if (departments.length == 0) {
      dispatch(getAllDepartmenst());
    }
  }, [dispatch, departments.length]);
  const teams = Array.isArray(departments)
    ? [{ departmentId: -1, departmentName: 'All' }, ...departments]
    : [{ departmentId: -1, departmentName: 'All' }]; */
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        borderRadius: '10px',
        p: { xs: 0, md: 1.5 },
      }}
    >
      <Grid container spacing={{ xs: 1, md: 2 }} alignItems="center">
        <Grid item xs={6} md={2}>
          <DatePickerCustom
            label="From Date"
            value={dayjs(fromDate)}
            setValue={(date) => setFromDate(date.format('YYYY-MM-DD'))}
            viewDetails={['year', 'month', 'day']}
            fullWidth
            height={36}
            fontSize="0.75rem"
          />
        </Grid>

        <Grid item xs={6} md={2}>
          <DatePickerCustom
            label="To Date"
            value={dayjs(toDate)}
            setValue={(date) => setToDate(date.format('YYYY-MM-DD'))}
            viewDetails={['year', 'month', 'day']}
            fullWidth
            height={36}
            fontSize="0.75rem"
          />
        </Grid>
        {/*   <Grid item xs={6} md={2}>
          <GlobalSelectFieldWithoutFormikNew
            sx={{
              '& .MuiInputBase-root': {
                height: 36,
                fontSize: '0.75rem',
              },
            }}
            keys={{ itemId: 'departmentId', itemValue: 'departmentName' }}
            data={teams}
            label="Department"
            fullWidth
            selectedDetails={selectedDepartment}
            setChange={setSelectedDepartment}
          />
        </Grid>

        <Grid item xs={6} md={3}>
          <Stack direction="row" spacing={1}>
            <Button
              sx={{
                boxShadow: 'none',
                textTransform: 'none',
              }}
              size="small"
              variant="outlined"
              color="primary"
              onClick={() => {
                submitFunction();
              }}
            >
              Submit
            </Button>
            <Button
              sx={{
                boxShadow: 'none',
                textTransform: 'none',
              }}
              size="small"
              variant="outlined"
              color="primary"
              onClick={() => {
                handleClearFilter();
              }}
            >
              Clear Filter
            </Button> */}
        {/* </Stack> */}
        {/* </Grid> */}
      </Grid>
    </Box>
  );
};

export default FilterSectionFromToSubmit;
